import { IEnvironment } from 'interfaces-lib';
import { buildVersion } from './build.version';

export const environment: Partial<IEnvironment> = {
  appName: 'caddi',
  name: 'dev',
  kpHost: 'https://backend-dev.awesome-docs.io',
  kpWorkflowHost: 'https://backend-dev.awesome-docs.io',
  kpWorkflowStatus: 'wss://backend-dev.awesome-docs.io',

  uiHost: 'https://ad-ui-sandbox.awesome-docs.io',

  production: false,
  version: buildVersion + '-DEV',

  enableAnalytics: false,
};
